import { styled } from '@/stitches/index.js';
import { isTheme } from '@/stitches/isTheme.js';
import { dawn } from '@/templates/sydney/themes/dawn.js';
import { dusk } from '@/templates/sydney/themes/dusk.js';
import { midnight } from '@/templates/sydney/themes/midnight.js';

const Container = styled('div', {
  alignItems: 'center',
  background: '$defaultFont',
  color: '$pageBackground',
  display: 'flex',
  padding: '$12 0',
  [`${isTheme([dawn, dusk, midnight])}`]: {
    fontWeight: 500,
  },
  [`${isTheme([midnight])}`]: {
    background: '$secondaryFont',
    color: '$defaultFont',
  },
  position: 'relative',
  width: '100%',
  [`${isTheme([dusk])}`]: {
    color: '$secondaryFont',
  },
});

const MarqueeItem = styled('div', {
  '> *:first-child': {
    margin: '0 $10',
  },
  display: 'flex',
  fontSize: '$20',
  letterSpacing: '$3',
  margin: 0,
  textTransform: 'uppercase',
});

export { Container, MarqueeItem };
